import React from "react";
import styles from "./Tags.scss";
import ReactTags from "react-tag-autocomplete";
import { PropTypes } from "prop-types";

export const Tags = ({
    value,
    onAdd,
    onRemove,
    onInput,
    suggestions,
    suggestionsFilter,
    placeholder,
    minQueryLength,
    removeButtonText,
    allowNew
}) => {
    return (
        <ReactTags
            classNames={styles}
            placeholderText={placeholder}
            tags={value}
            onAddition={onAdd}
            onDelete={onRemove}
            onInput={onInput}
            suggestions={suggestions}
            suggestionsFilter={suggestionsFilter}
            allowNew={allowNew}
            removeButtonText={removeButtonText}
            allowBackspace={false}
            minQueryLength={minQueryLength}
        />
    );
};

Tags.defaultProps = {
    value: [],
    allowNew: true,
    suggestions: [],
    removeButtonText: "Klikk for å fjerne",
    minQueryLength: 1,
    suggestionsFilter: () => {
        return true;
    }
};

Tags.propTypes = {
    /**
     * Array with tags
     */
    value: PropTypes.array,
    /**
     * Function called when adding new tag
     */
    onAdd: PropTypes.func,
    /**
     * Function called when removing tag. Returns tag index.
     */
    onRemove: PropTypes.func,
    /**
     * Function called when input is being typed
     */
    onInput: PropTypes.func,
    /**
     * Array with suggestions
     */
    suggestions: PropTypes.array,
    /**
     * Filter suggestions
     */
    suggestionsFilter: PropTypes.func,
    /**
     * Placeholder text to display in input
     */
    placeholder: PropTypes.string,
    /**
     * Hover text for tags
     */
    removeButtonText: PropTypes.string,
    /**
     * Allow creating tags that are not in suggestions
     */
    allowNew: PropTypes.bool,
    /**
     * Minimum query length required to show the suggestions list
     */
    minQueryLength: PropTypes.number
};
